(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["laerke-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('laerke-photo-reviews')) {
    customElements.define('laerke-photo-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.lpr__track');
        this.cards = Array.from(this.querySelectorAll('.lpr__card'));
        this.nav = this.querySelector('.lpr__navigation');
        this.prev = this.querySelector('[data-lpr-prev]');
        this.next = this.querySelector('[data-lpr-next]');
        this.dots = this.querySelector('.lpr__dots');
        this.status = this.querySelector('.lpr__status');
        this.positions = [];
        this.index = 0;
        if (!this.track || !this.cards.length) return;
        this.prev?.addEventListener('click', () => this.go(this.index - 1), {signal});
        this.next?.addEventListener('click', () => this.go(this.index + 1), {signal});
        this.dots?.addEventListener('click', event => {
          const dot = event.target.closest('[data-position]');
          if (dot) this.go(Number(dot.dataset.position));
        }, {signal});
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
        }, {passive: true, signal});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (!keys.includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.go(0);
          else if (event.key === 'End') this.go(this.positions.length - 1);
          else this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, {signal});
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
          if (!card) return;
          const left = card.offsetLeft - this.cards[0].offsetLeft;
          const index = this.positions.findIndex(position => position >= left - 2);
          this.go(index < 0 ? this.positions.length - 1 : index);
        }, {signal});
        this.resize = new ResizeObserver(() => this.layout());
        this.resize.observe(this.track);
        this.layout();
        this.classList.add('is-ready');
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.resize?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
      layout() {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const positions = [0];
        for (const card of this.cards.slice(1)) {
          const position = Math.min(max, card.offsetLeft - this.cards[0].offsetLeft);
          if (position - positions[positions.length - 1] > 2) positions.push(position);
        }
        if (max - positions[positions.length - 1] > 2) positions.push(max);
        this.positions = positions;
        if (this.dots && this.dots.children.length !== positions.length) {
          this.dots.replaceChildren(...positions.map((position, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'lpr__dot';
            button.dataset.position = index;
            button.setAttribute('aria-label', this.dataset.dotLabel.replace('__number__', index + 1));
            return button;
          }));
        }
        this.nav.hidden = max <= 2 || (!this.prev && !this.next && !this.dots);
        this.sync();
      }
      sync() {
        const left = this.track.scrollLeft;
        this.index = this.positions.reduce((best, position, index) => Math.abs(position - left) < Math.abs(this.positions[best] - left) ? index : best, 0);
        if (this.prev) this.prev.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.positions.length - 1;
        if (this.dots) Array.from(this.dots.children).forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
        if (this.status) this.status.textContent = this.dataset.counterLabel.replace('__current__', this.index + 1).replace('__total__', this.positions.length);
      }
      go(index) {
        const target = Math.max(0, Math.min(this.positions.length - 1, index));
        this.track.scrollTo({left: this.positions[target], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
